import React from "react";
import PropTypes from "prop-types";
import { Input, Select, Space, Popover } from "antd";
import {
  DateOfMonth,
  LastDay,
  WeekOfMonth,
  weekSetValueHandler,
  daySetValueHandler,
  QuarterlyMonth,
  YearlyMonth,
  QuaterlyMonthChangeHandler,
  YearlyMonthChangeHandler,
} from "../ScheduleElements";
import {
  getScheduleVal,
  getScheduleContent,
  QUARTERLY,
  YEARLY,
  WEEKLY,
  MONTHLY,
} from "../../../utils/report";

const { Option } = Select;

const ScheduleWeekdayElement = ({ record, updateField, errorStatus }) => {
  let innerElement = null;
  const updateMonthDateFn = (e) => {
    const selectedRecord = record;
    let monthval = "";
    if (
      selectedRecord.shedule_type === QUARTERLY ||
      selectedRecord.shedule_type === YEARLY
    ) {
      monthval = getScheduleVal(selectedRecord, 3);
      if (monthval === undefined) {
        monthval = "1";
      }
      if (typeof monthval === "string") {
        monthval += "_";
      }
    }
    updateField(monthval + e.target.value);
  };

  switch (record.schedule_trigger_type) {
    case 1:
      innerElement = (
        <DateOfMonth
          value={getScheduleVal(record, 4)}
          onChange={updateMonthDateFn}
          reportType={record.shedule_type}
          month={getScheduleVal(record, 3)}
        >
          {[QUARTERLY, MONTHLY].includes(record.shedule_type) ? (
            <LastDay
              checked={getScheduleVal(record, 4) === "lastday"}
              onChange={updateMonthDateFn}
            />
          ) : null}
        </DateOfMonth>
      );
      break;
    case 2:
      innerElement = (
        <WeekOfMonth
          week={getScheduleVal(record, 1)}
          day={getScheduleVal(record, 2)}
          changeWeekHandler={(e) => {
            const setval = weekSetValueHandler(e.target.value, record);
            updateField(setval);
          }}
          changeDayHandler={(e) => {
            const setval = daySetValueHandler(e.target.value, record);
            updateField(setval);
          }}
        />
      );
      break;
    default:
      return record.shedule_type === WEEKLY ? (
        <Select
          placeholder="Please Select Schedule"
          value={record.schedule_weekday}
          status={errorStatus ? "error" : ""}
          onChange={(e) => updateField(e)}
          style={{ width: "100%" }}
        >
          <Option value="Monday">Monday</Option>
          <Option value="Tuesday">Tuesday</Option>
          <Option value="Wednesday">Wednesday</Option>
          <Option value="Thursday">Thursday</Option>
          <Option value="Friday">Friday</Option>
          <Option value="Saturday">Saturday</Option>
          <Option value="Sunday">Sunday</Option>
        </Select>
      ) : (
        <Select
          placeholder="Please Select Schedule"
          disabled
          style={{ width: "100%" }}
        />
      );
  }

  // TODO: need to re-factor
  // console.log(record,index,scheduletype)
  let monthselect = null;
  //define month select element
  switch (record.shedule_type) {
    case QUARTERLY:
      monthselect = (
        <QuarterlyMonth
          value={getScheduleVal(record, 3)}
          onChange={(e) => {
            const setvalue = QuaterlyMonthChangeHandler(e.target.value, record);
            updateField(setvalue);
          }}
        />
      );
      break;
    case YEARLY:
      monthselect = (
        <YearlyMonth
          value={getScheduleVal(record, 3)}
          onChange={(e) => {
            // console.log(e, 'change triggered')
            const setvalue = YearlyMonthChangeHandler(
              e,
              record,
              record.shedule_type,
            );
            updateField(setvalue);
          }}
        />
      );
      break;
    default:
      monthselect = null;
  }

  //define schedule input element
  let scheduleInput = null;
  if (
    record.schedule_trigger_type === 1 ||
    record.schedule_trigger_type === 2
  ) {
    scheduleInput = (
      <Input
        // className={this.invalidField("schedule_weekday") ? classes.error : ""} // tobe updated
        status={errorStatus ? "error" : ""}
        placeholder="Please Select Schedule"
        value={getScheduleContent(record)}
      />
    );
  }

  return (
    <Popover
      content={
        <div>
          <Space direction="vertical">
            {monthselect}
            {innerElement}
          </Space>
        </div>
      }
      trigger="click"
    >
      {scheduleInput}
    </Popover>
  );
};

ScheduleWeekdayElement.propTypes = {};

export default ScheduleWeekdayElement;
